<div class="sidebar">
  <div class="sidebar-logo" (click)="refreshPage()">
    <img [src]="logoPath" alt="Logo" class="logo-size" />
    <span class="sidebar-label">HES</span>
  </div>

  @if (!authService.isBpsAdmin()) {
  <div class="sidebar-nav">
    <div class="menu-item" [routerLink]="['analytics']" [ngClass]="{ selected: isActive('analytics') }">
      <svg-icon src="assets/sidebar/sidebar-analytics.svg" alt="Analytics"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_ANALYTICS" | translate }}</span>
    </div>

    @if (authService.isAuthorized([PermissionsEnum.Device_view])) {
    <div class="menu-item" [routerLink]="['/devices/all-devices']" routerLinkActive="active" [ngClass]="{ selected: isActive('devices') }">
      <svg-icon src="assets/sidebar/sidebar-device.svg" alt="Device"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_DEVICE" | translate }}</span>
    </div>
    }

    @if (
      authService.isAuthorized([PermissionsEnum.Alarms_realtime_view]) ||
      authService.isAuthorized([PermissionsEnum.Alarms_ondemand_view])
    ) {
    <div class="menu-item" [routerLink]="['events']" [ngClass]="{ selected: isActive('events') }">
      <svg-icon src="assets/sidebar/sidebar-events.svg" alt="Events & Alarms"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_EVENTS" | translate }}</span>
    </div>
    }

    @if (authService.isAuthorized([PermissionsEnum.Ondemand_billingdata_view])) {
    <div class="menu-item" [routerLink]="['/billing-data']" [ngClass]="{ selected: isActive('billing-data') }">
      <svg-icon src="assets/sidebar/sidebar-loadProfile.svg" alt="Billing Data"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_BILLINGDATA" | translate }}</span>
    </div>
    }

    @if (
      authService.isAuthorized([PermissionsEnum.Ondemand_loadprofile_view]) ||
      authService.isAuthorized([PermissionsEnum.Ondemand_energyregister_view]) ||
      authService.isAuthorized([PermissionsEnum.Ondemand_instantaneousobject_view]) ||
      authService.isAuthorized([PermissionsEnum.Ondemand_powerdemandregister_view])
    ) {
    <div class="menu-item" [routerLink]="['/on-demand/load-profile']" [ngClass]="{ selected: isActive('on-demand/') }">
      <svg-icon src="assets/sidebar/sidebar-on-demand.svg" alt="On Demand Data Read"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_ONDEMANDDATAREAD" | translate }}</span>
    </div>
    }

    @if (
      authService.isAuthorized([PermissionsEnum.Scheduled_energyregister_view]) ||
      authService.isAuthorized([PermissionsEnum.Scheduled_instantaneousobject_view]) ||
      authService.isAuthorized([PermissionsEnum.Scheduled_loadprofile_view]) ||
      authService.isAuthorized([PermissionsEnum.Scheduled_powerdemandregister_view]) ||
      authService.isAuthorized([PermissionsEnum.Scheduled_event_log_view])
    ) {
    <div class="menu-item" [routerLink]="['/scheduled']" [ngClass]="{ selected: isActive('scheduled/') }">
      <svg-icon src="assets/sidebar/sidebar-realtimeData.svg" alt="Scheduled Data Read"></svg-icon>
      <span class="sidebar-label">{{ "SCHEDULEDDATAREAD" | translate }}</span>
    </div>
    }

    <div class="menu-item" [routerLink]="['/tariffs']" routerLinkActive="active" [ngClass]="{ selected: isActive('tarriff') }">
      <svg-icon src="assets/sidebar/sidebar-tariffManagement.svg" alt="Tariff Management"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_TARRIFMANAGEMENT" | translate }}</span>
    </div>

    @if (
      authService.isAuthorized([PermissionsEnum.Remotecommands_connectdisconnect_view]) ||
      authService.isAuthorized([PermissionsEnum.Remotecommands_tokenload_view]) ||
      authService.isAuthorized([PermissionsEnum.Remotecommands_clearcredit_view]) ||
      authService.isAuthorized([PermissionsEnum.Remotecommands_cleartamper_view])
    ) {
    <div class="menu-item" [routerLink]="['/remote-command/connect-disconnect']" [ngClass]="{ selected: isActive('remote-command') }">
      <svg-icon src="assets/sidebar/sidebar-remoteCommand.svg" alt="Remote Command"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_REMOTECOMMAND" | translate }}</span>
    </div>
    }

    @if (authService.isAuthorized([PermissionsEnum.Device_firmware_update])) {
    <div class="menu-item" [routerLink]="['/firmware-update-group']" [ngClass]="{ selected: isActive('firmware-update-group') }">
      <svg-icon src="assets/sidebar/satellite.svg" alt="Firmware Update"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_FIRMWAREUPDATE" | translate }}</span>
    </div>
    }

    @if (
      authService.isAuthorized([PermissionsEnum.Loadlimit_view]) ||
      authService.isAuthorized([PermissionsEnum.Loadlimit_add]) ||
      authService.isAuthorized([PermissionsEnum.Loadlimit_modify]) ||
      authService.isAuthorized([PermissionsEnum.Loadlimit_delete])
    ) {
    <div class="menu-item" [routerLink]="['/load-limit']" [ngClass]="{ selected: isActive('load-limit') }">
      <svg-icon src="assets/sidebar/sidebar-loadlimit.svg" alt="Load Limit Management"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_LOADLIMITMANAGEMENT" | translate }}</span>
    </div>
    }

    @if (
      authService.isAuthorized([PermissionsEnum.Systemmonitoring_acquisition_view]) ||
      authService.isAuthorized([PermissionsEnum.Systemmonitoring_deviceconnectiontime_view])
    ) {
    <div class="menu-item" [routerLink]="['/system-monitoring/acquisition']" [ngClass]="{ selected: isActive('system-monitoring') }">
      <svg-icon src="assets/sidebar/sidebar-system-monitoring.svg" alt="System Monitoring"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_SYSTEMMONITORING" | translate }}</span>
    </div>
    }

    @if (
      authService.isAuthorized([PermissionsEnum.Report_fraudulent_meters_view]) ||
      authService.isAuthorized([PermissionsEnum.Report_meter_time_sync_view]) ||
      authService.isAuthorized([PermissionsEnum.Report_prepayment_view])
    ) {
    <div class="menu-item" [routerLink]="['/analysis-report']" [ngClass]="{ selected: isActive('analysis-report') }">
      <svg-icon src="assets/sidebar/sidebar-analysis-report.svg" alt="Analysis Report"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_ANALYSIS_REPORT" | translate }}</span>
    </div>
    }

    <div class="menu-item" [ngClass]="{ selected: isActive('support') }" (click)="toastr.warning('Not implemented.')">
      <svg-icon src="assets/sidebar/sidebar-support.svg" alt="Support"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_SUPPORT" | translate }}</span>
    </div>


  </div>
  <div class="sidebar-footer">
    <div class="menu-item" [routerLink]="['/meter-setup-desktop-app']" [ngClass]="{ selected: isActive('meter-setup-desktop-app') }">
      <svg-icon src="assets/sidebar/sidebar-desktop-app.svg" alt="Meter Setup Desktop App"></svg-icon>
      <span class="sidebar-label">{{ "METER_SETUP_DESKTOP_APP" | translate }}</span>
    </div>
    @if (
      authService.isAuthorized([PermissionsEnum.Settings_crud_region_view]) ||
      authService.isAuthorized([PermissionsEnum.Settings_crud_area_view]) ||
      authService.isAuthorized([PermissionsEnum.Settings_crud_assettype_view]) ||
      authService.isAuthorized([PermissionsEnum.Settings_crud_metermake_view]) ||
      authService.isAuthorized([PermissionsEnum.Settings_crud_metermodel_view]) ||
      authService.isAuthorized([PermissionsEnum.Settings_crud_servicetype_view])
    ) {
    <div class="menu-item" [routerLink]="['/settings/crud/region']" routerLinkActive="active" [ngClass]="{ selected: isActive('settings') }">
      <svg-icon src="assets/sidebar/sidebar-settings.svg" alt="Settings"></svg-icon>
      <span class="sidebar-label">{{ "SIDEBAR_SETTINGS" | translate }}</span>
    </div>
    }
    <div class="menu-item" [routerLink]="['/account/profile']" [ngClass]="{ selected: isActive('account') }">
      @if (user.image !== '/' && user.image !== '') {
      <img class="user-avatar circle-img" src="data:image/jpeg;base64,{{ user.image }}" alt="User" />
      } @else {
      <img class="user-avatar" src="assets/sidebar/sidebar-userName.svg" alt="User" />
      }
      <span class="sidebar-label">{{ user.firstName }}</span>
    </div>
  </div>
  } @else {
  <div class="sidebar-nav">
    <div class="menu-item" [routerLink]="['utilities/all']" [ngClass]="{ selected: isActive('utilities') }">
      <svg-icon src="assets/sidebar/sidebar-utilities.svg" alt="Utilities"></svg-icon>
      <span class="sidebar-label">{{ "UTILITIES" | translate }}</span>
    </div>
  </div>
  }
</div>
